import { render, staticRenderFns } from "./SyntheseStructure.vue?vue&type=template&id=08adb3ff&scoped=true"
import script from "./SyntheseStructure.vue?vue&type=script&lang=js"
export * from "./SyntheseStructure.vue?vue&type=script&lang=js"
import style0 from "./SyntheseStructure.vue?vue&type=style&index=0&id=08adb3ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08adb3ff",
  null
  
)

export default component.exports